<template>
  <div class="privacy-policy">
    <nav class="navbar">
      <div class="navbar-logo">
        <img class="logo" src="@/assets/logo.png" alt="QuickMatrixTool Logo" />
        <p>Quick Matrix Tool</p>
      </div>
      <ul class="navbar-links">
        <li><router-link to="/">返回首页</router-link></li>
      </ul>
    </nav>
    <div class="content">
      <section>
        <h1 class="text-2xl font-bold">Privacy Policy</h1>
        <p>Last updated: 2025/03/07</p>
        <p>
          QuickMatrixTool致力于保护您的隐私。我们只会出于特定目的收集您的个人信息。我们不会分发或共享您的个人信息,除非是为了履行我们对您的义务而严格必要。我们只会与遵守保护您隐私承诺的合作伙伴共享您的信息。QuickMatrixTool不会以任何方式出售您的个人信息。
        </p>
      </section>

      <section>
        <h2 class="text-xl font-semibold">收集、处理和传递个人数据</h2>
        <p>原则上,您无需留下任何个人信息即可使用我们的应用。我们仅收集您自愿提供的个人信息,目前仅有的场景为:</p>
        <br />
        <p>当您在我们的应用下订单时。</p>
      </section>

      <section>
        <h2 class="text-xl font-semibold">我们收集哪些信息?我们用这些信息做什么?</h2>
        <p>当您在我们的应用下订单时,会记录当前设备的ID。这些信息用于完成交易并帮助我们为您提供更好的支持和服务。</p>
      </section>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from '../components/QuickMatrixFooter.vue'
export default {
  name: 'PrivacyPolicy',
  components: {
    Footer,
  },
}
</script>

<style scoped>
.privacy-policy {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, #000000 .14%, #333333 99.88%);
}

.navbar {
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  background-color: #151910;
  color: #fff;
  height: 60px;
  z-index: 1000;
  flex-shrink: 0;
}

.navbar-logo {
  display: flex;
  padding: 0;
  margin: 0;
  height: 60px;
}

.logo {
  height: 36px;
  padding: 12px 12px 12px 24px;
  color: #ccc;
}

.navbar-logo p {
  color: #ccc;
  font-size: 24px;
  font-family: "Times New Roman", Times, serif;
  height: 36px;
  padding: 16px 0 12px 0;
  margin: 0;
}

.navbar-links {
  list-style: none;
  display: flex;
  gap: 15px;
  margin: 0 10% 0 0;
  padding: 0;
}

.navbar-links li a {
  text-decoration: none;
  font-size: 18px;
  color: #ccc;
  margin: 0;
}

.navbar-links li a:hover {
  color: #fff;
}

h1 {
  margin-top: 20px;
  color: #fff;
}

h2 {
  margin-top: 40px;
  color: #fff;
}

p {
  margin-top: 0;
  color: #eee;
  line-height: 1.7;
}

section {
  margin-left: 10%;
  margin-right: 10%;
  max-width: 60%;
}

.content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  text-align: left;
  padding: 0 0 32px;
  margin: 0;
}

@media (max-width: 768px) {
  .navbar {
    height: 56px;
  }
  .logo {
    height: 28px;
    padding: 14px 8px 14px 16px;
  }
  .navbar-logo p {
    font-size: 18px;
    padding: 18px 0 12px 0;
    height: 28px;
  }
  .navbar-links {
    margin-right: 16px;
  }
  .navbar-links li a {
    font-size: 15px;
  }
  section {
    margin-left: 16px;
    margin-right: 16px;
    max-width: calc(100% - 32px);
  }
  h1 {
    font-size: 1.6rem;
  }
  h2 {
    font-size: 1.2rem;
    margin-top: 28px;
  }
  p {
    font-size: 0.95rem;
  }
}
</style>
